import { createTheme } from '@mui/material/styles';

// Define your custom theme
const theme = createTheme({
  typography: {
    fontFamily: 'Inter',
    fontSize: 14,
    lineHeight: '20px',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h4: {
      fontSize: '28px',
      lineHeight: '40px',
      fontWeight: 700
    },
    h5: {
      fontSize: '24px',
      lineHeight: '32px',
      fontWeight: 700
    },
    h6: {
      fontSize: '18px',
      lineHeight: '28px',
      fontWeight: 700
    },
    h8: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: 700
    },
    h10: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400
    },
    body1: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '22px'
    },
    small: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px'
    },
    extraSmall: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '18px'
    }
  },
  palette: {
    primary: {
      main: '#005CBC'
    },
    secondary: {
      main: '#005CBC'
    },
    grey: {
      800: '#272727' // Black background for the header (AppBar)
    },
    text: {
      primary: '#3A3A3A',
      secondary: '#616161'
    },
    background: {
      default: '#f5f5f5' // Default background (optional)
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Disable uppercase transformation
          borderRadius: '24px',
          boxShadow: 'none',
          fontWeight: 700,
          '&:hover': {
            boxShadow: 'none', // Ensure no box shadow on hover
          },
          '&:active': {
            boxShadow: 'none', // Ensure no box shadow when pressed
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#004A96', // Hover color for primary button
          },
          '&:active': {
            backgroundColor: '#003771', // Pressed color for primary button
          },
        },
        outlinedSecondary: {
          borderColor: '#005CBC', // Ensure the border is set for secondary outlined buttons
          '&:hover': {
            backgroundColor: 'inherit', // Keep background color unchanged
            color: '#004A96', // Change text color on hover
            borderColor: '#004A96', // Change border color on hover
          },
          '&:active': {
            backgroundColor: 'inherit', // Keep background color unchanged
            color: '#003771', // Change text color on press
            borderColor: '#003771', // Change border color on press
          },
        },
    },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff', // White background for Drawer
          color: '#000000' // Black text for Drawer
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: '1px solid #D7E5F8',
          borderRadius: '4px',
          boxShadow: '0px 4px 24px 0px #3A3A3A14',
          padding: '8px'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          color: '#616161',
          '&:not(:last-child)': {
            borderBottom: '1px solid #DFDFDF'
          }
        }
      }
    }
  }
});

export default theme;
